export const TVING_PARTNER = 'tving_partner'
export const WAVVE = 'wavve'
export const PARTNER = 'partner'

export const PARTNER_FAQ_PATH = '/customer/faq?filterId=188'
export const PARTNER_NOTICE_PATH =
  '/customer/notice_view?filterType=service&noticeId=3719'
export const TVING_ACCOUNT_CONNECT_PATH =
  'https://www.tving.com/bill/activation?purchaseCode=WAVVE_BUNDLE'
export const TVING_NOTICE_LINKS_PC_WEB =
  'https://www.tving.com/membership/tving?tab=wavve'
export const TVING_NOTICE_LINKS_MOBILE_WEB =
  'https://bill.tving.com/bill/productList.tving?focusType=TVING_BUNDLE'

export const VOUCHER_TYPE = {
  WAVVE,
  TVING_PARTNER,
  PARTNER,
}

export const VOUCHER_TYPE_MAP = {
  wavve: VOUCHER_TYPE.WAVVE,
  partner: VOUCHER_TYPE.PARTNER,
  tving_partner: VOUCHER_TYPE.TVING_PARTNER,
}

export const VOUCHER_BANNER_MAP = {
  wavve: 0,
  partner: 0,
  tving_partner: 1,
}

export const VOUCHER_TICKET_LIST = [
  {
    key: WAVVE,
    title: '웨이브 이용권',
  },
  {
    key: TVING_PARTNER,
    title: '웨이브 x 티빙 더블 이용권',
  },
  {
    key: PARTNER,
    title: '제휴 이용권',
  },
]

// 더블 이용권 공통 혜택
export const VOUCHER_INTEGRATED_BENEFITS = [
  {
    title: '웨이브',
    benefits: [
      `웨이브 오리지널 콘텐츠`,
      `지상파 등 30만편 이상의 VOD 및 라이브 방송 (SBS 시청 제한)`,
      `영화 6천편 무제한 시청 (영화플러스 개별구매 별도)`,
      `모바일APP 다운로드 무제한`,
    ],
  },
  {
    title: '티빙',
    benefits: [
      `티빙 오리지널 콘텐츠`,
      `tvN, JTBC, Mnet 프로그램, 영화, 해외 시리즈`,
      `스포츠 중계와 라이브 방송`,
      `AppleTV+의 인기 콘텐츠까지`,
    ],
  },
]

export const NOTICE_SBS_LIMIT_TITLE = '더블 이용권\n일부 콘텐츠 시청 제한 안내'
export const NOTICE_SBS_LIMIT_DESCRIPTION = `더블 이용권은 방송사의 요청에 따라\n일부 콘텐츠의 시청이 제한되는 점 양해 부탁드립니다.\n\n제한 대상 : LINK1__SBS 콘텐츠__`
export const NOTICE_SBS_LIMIT_CONFIRM_TEXT = '더블 이용권 구매하기'
export const NOTICE_SBS_LIMIT_DESCRIPTION_LINKS = {
  LINK1: { href: PARTNER_NOTICE_PATH, attr: { target: '_blank' } },
}
